import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'custom-modal-card',
  standalone: false,
  templateUrl: './custom-modal-card.component.html',
  styleUrls: ['./custom-modal-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CustomModalCardComponent {
  enableHeader = input<boolean>(true);
  enableBody = input<boolean>(true);
  enableFooter = input<boolean>(true);
  modalExtraClasses = input<string | string[]>([]);
  enableClose = input<boolean>(true);
}
